import logo from "@/images/svgs/mkeTool_white.svg";
export const MkeLogo = () => (
  <img height={40} width={90} src={logo} alt="Milwaukee Tool" />
);
